module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div')
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b37882d4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/web/esocial/s2210.vue
// module id = 1578
// module chunks = 45